export class InfoCertificatoDTO {

    signer: boolean;

    givenName: string;

    identifier: string;

    surname: string;

    subjectOrganization: string;

    caOrganization: string;

    notAfter: number;

    notBefore: number;

    checkResult: string;

    valid: string;

}   